<template>
  <div class="card" id="orderPreviewCard">
      <div class="card-header mt-3">
          <h5 class="card-title text-center">Order Preview</h5>
          <hr>
      </div>
      <div class="card-body">
          <div class="row mb-2">
              <div class="col-4">
                <BasicTextInput label="Order #" :disabled="true" v-model="order.OrderNumber"/>
              </div>
              <div class="col-5">
                <BasicTextInput label="Customer" :disabled="true" v-model="order.CustomerName"/>
              </div>
              <div class="col-3">
                <button type="button" @click="openInNewTab" class="btn btn-primary button tab-button">
                  <i class="fa fa-edit" aria-hidden="true"></i> Edit in New Tab
                </button>
              </div>

              <div class="col-4">
                <BasicTextInput label="Created" :disabled="true" v-model="orderCreatedOn"/>
              </div>
              <div class="col-4">
                <BasicTextInput label="Last Revised" :disabled="true" v-model="orderRevisedOn"/>
              </div>
          </div>

          <div :key="OrderGridUpdateKey" class="order-view">
            <CustomerOrderGrid 
              v-for="(bundle, index) in bundles"
              ref="'CustomerOrderGrid'"
              :key="bundle.OrderLineGroupId"
              :readOnly="true"
              :dataSource="orderLinesSortedByLineNumber"
              :columns="datagridColumns"
              :OrderLineGroupName="bundle.OrderLineGroupName"
              :OrderLineGroupId="bundle.OrderLineGroupId"
              :BundleQuantity="bundle.Quantity"
              :PrintOptionId="bundle.PrintOptionId"
              :bundleIsImported="bundle.IsImported"
              :totalsSummary="totalsSummary[index]"
              :detailView="false"
              :gridIndex="index"
              :multiSelect="false"
              :searchEntireGrid="false"
              :searchByColumn="false"
              :showColumnLines="true"
              :allow-column-resizing="true"
              :column-auto-width="false"
              :row-alternation-enabled="true"
            />
          </div>
      </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { OrderService } from '@/services';
  import { BasicDataGrid } from '.';
  import { CustomerOrderGrid } from '.';
  import * as moment from 'moment';

  export default {
    name: "OrderPreview",
    props: {
        orderId: {
            type: Number,
            default: 0
        }
    },
    data: () => {
        return {
            order: {},
            orderLines: [],
            bundles: [],
            totalsSummary: [],
            OrderGridUpdateKey: 0,
            datagridColumns: [
                { text: "Qty", value: "Quantity" },
                { text: "MFI", value: "MFI" },
                { text: "Part #", value: "PartNumber" },
                { text: "Description", value: "Description" },
                { text: "Retail", value: "Retail" },
                { text: "Customer Cost", value: "CustomerCost" },
                { text: "Customer Extended", value: "CustomerExtended" },
                { text: "Stock Code", value: "StockCode" }
            ],
        };
    },
    watch: {},
    computed: {
        ...mapState(["currentUser"]),
        orderCreatedOn() {
            return this.order ? moment(this.order.CreatedOn).format("L") + " " + moment(this.order.CreatedOn).format("LTS") : "";
        },
        orderRevisedOn() {
            return this.order ? moment(this.order.RevisedOn).format("L") + " " + moment(this.order.RevisedOn).format("LTS") : "";
        },
        orderLinesSortedByLineNumber(){
            return this.sortOrderLinesByLineNumber()
        },
    },
    mounted() {
        this.loadOrder();
    },
    methods: {
        loadOrder() {
            OrderService.get({ id: this.orderId })
                .then(res => {
                    this.order = res;
                    this.orderLines = this.sortOrderLinesByLineNumber(res.OrderLines);
                    this.bundles = res.Bundles;
                    this.bundles = this.sortBundles();

                    //console.debug('BUNDLES: ', this.bundles)

                    for (const line of this.orderLines) {
                      line.Id = line.OrderLineId
                    }

                    this.resetBundleTotals()
                })
                .catch(err => {
                  this.$store.dispatch("ADD_NOTIFICATION", { text: err.response.data.Message, type: "error" });
                });
        },
        sortOrderLinesByLineNumber(orderLines = this.orderLines){
          return orderLines.sort(function(a, b) {
              var line1 = a.LineNumber;
              var line2 = b.LineNumber;
              return (line1 < line2) ? -1 : (line1 > line2) ? 1 : 0;
          });
        },
        sortBundles(){
          return this.bundles.sort(function(a, b) {
              var idA = a.OrderLineGroupId;
              var idB = b.OrderLineGroupId;
              return (idA < idB) ? -1 : (idA > idB) ? 1 : 0;
          });
        },
        resetBundleTotals(){
            if(this.orderLines.length <= 0) return;
            this.totalsSummary = []
            this.bundles.forEach(bundle => {
                this.totalsSummary.push({...this.emptyTotal, id: bundle.OrderLineGroupId})
            })
        },
        openInNewTab() {
          const orderId = this.order.Id;
          const customerId = this.order.CustomerId;
          const routeData = this.$router.resolve({ name: 'CustomerOrderEdit', params: { id: orderId, cid: customerId } });
          window.open(routeData.href, '_blank');
        }
    },
    components: { BasicDataGrid, CustomerOrderGrid }
}
</script>

<style scoped lang="scss">
  .card {
      min-width: 300px;
      max-width: 1200px;
      width: 80vw;
      max-height: 90vh;
  }

  #orderPreviewCard {
      min-width: 900px;
      min-height: 700px;
  }

  .col-4 {
      z-index: 99;
  }

  .order-view {
    margin-top: 25px;
    overflow-y: scroll;
    height: 60vh;
  }

  .tab-button {
    margin-top: 25px;
  }
</style>
